var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ai-assessment-creation"},[_c('LeftPanel',{on:{"loading-complete":_vm.onLeftPanelLoadingComplete}}),_c('div',{staticClass:"right-panel"},[_c('ChatInterface')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }